module.exports = __webpack_public_path__ + "static/media/app-mockup.0926ab47.png";